import {
  AppTemplate,
  Inquiry,
  Landing,
  LipReadingContribution,
  LipReadingDemonstration,
  LipReadingDemonstrationManual,
  LipReadingVerification,
  LipReadingWordList,
  LipReadingWords,
  Login,
  MyPageChangeEmail,
  MyPageChangePassword,
  MyPageInfo,
  NotificationsEdit,
  NotificationsList,
  NotificationsNew,
  PrivacyPolicy,
  ResetPassword,
  Signup,
  Terms,
  UsersDetail,
  UsersList,
} from 'components/screens'
import React from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { Dispatch } from 'redux'
import User from 'redux/models/user'
import { AuthState, actions } from 'redux/modules/auth'
import { AppState } from 'redux/store'
import { Action } from 'typescript-fsa'

interface RouterActions {
  load: () => Action<void>
}

interface RouterProps {
  auth: AuthState
}

const requireAuth = (user: User | null, element: React.ReactNode) => {
  return user !== null ? <AppTemplate>{element}</AppTemplate> : <Navigate replace to="/login" />
}

const onlyEditor = (user: User | null, element: React.ReactNode) => {
  return user?.isEditor ? requireAuth(user, element) : <Navigate replace to="/" />
}

class Router extends React.Component<RouterProps & RouterActions> {
  componentDidMount(): void {
    this.props.load()
  }

  render = (): React.ReactNode => {
    const { user, loading, loaded } = this.props.auth

    // ユーザー読み込み待ち
    if (loading || !loaded) {
      return <div></div>
    }

    return (
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/password_reset" element={<ResetPassword />} />

            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy_policy" element={<PrivacyPolicy />} />

            <Route path="/notifications" element={requireAuth(user, <NotificationsList />)} />
            <Route path="/lip-reading/demonstration" element={requireAuth(user, <LipReadingDemonstration />)} />
            <Route
              path="/lip-reading/demonstration/manual"
              element={requireAuth(user, <LipReadingDemonstrationManual />)}
            />
            <Route path="/lip-reading/contribution" element={requireAuth(user, <LipReadingContribution />)} />
            <Route path="/mypage" element={requireAuth(user, <MyPageInfo />)} />
            <Route path="/mypage/changeEmail" element={requireAuth(user, <MyPageChangeEmail />)} />
            <Route path="/mypage/changePassword" element={requireAuth(user, <MyPageChangePassword />)} />
            <Route path="/inquiry" element={requireAuth(user, <Inquiry />)} />

            <Route path="/notifications/new" element={onlyEditor(user, <NotificationsNew />)} />
            <Route path="/notifications/:notificationId/edit" element={onlyEditor(user, <NotificationsEdit />)} />
            <Route path="/lip-reading/verification" element={onlyEditor(user, <LipReadingVerification />)} />
            <Route path="/lip-reading/words" element={onlyEditor(user, <LipReadingWordList />)} />
            <Route path="/lip-reading/words/:listId" element={onlyEditor(user, <LipReadingWords />)} />
            <Route path="/users" element={onlyEditor(user, <UsersList />)} />
            <Route path="/users/:userId" element={onlyEditor(user, <UsersDetail />)} />

            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </BrowserRouter>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>): RouterActions => {
  return {
    load: (): Action<void> => dispatch(actions.load()),
  }
}

const mapStateToProps = (state: AppState): RouterProps => ({
  auth: state.auth,
})

export default connect(mapStateToProps, mapDispatchToProps)(Router)
